module.exports = __webpack_public_path__ + "media/backgrounds/hector-john-periquin-aGrPtiRXX9s-unsplash-4949204c.jpg";